import * as React from 'react';
import { Seo } from './seo.js';
import '../styles/styles.css';
import Footer from './Footer.js';

export default function SinglePhotoLayout({
  location,
  children,
  title = false,
  description = false,
  image = false,
  path = false,
  ogType = 'image',
}) {
  return (
    <>
      <Seo
        title={title}
        description={description}
        image={image}
        path={path}
        ogType={ogType}
      />

      <main className='containerPhoto'>{children}</main>
      <Footer />
    </>
  );
}
